export default __webpack_public_path__ + "static/media/waypointsCluster.b1c24369.svg";